import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../common/api";
import { APIEndPoints } from "../common/endPoint";

export const createPromoCode = createAsyncThunk(
  "createPromoCode",
  async (body) => {
    const obj = {
      url: `${APIEndPoints.PromoCodesAPI}`,
      method: "POST",
      body: JSON.stringify(body),
    };
    return await API(obj);
  }
);

export const updatePromoCode = createAsyncThunk(
  "updatePromoCode",
  async ({ promo_id, body }) => {
    const obj = {
      url: `${APIEndPoints.PromoCodesAPI}${promo_id}/`,
      method: "PATCH",
      body: JSON.stringify(body),
    };
    return await API(obj);
  }
);

export const togglePromoCodeStatus = createAsyncThunk(
  "togglePromoCodeStatus",
  async ({ promo_id, body }) => {
    const obj = {
      url: `${APIEndPoints.PromoCodeToggleStatusAPI}${promo_id}/toggle-status/`,
      method: "POST",
      body: JSON.stringify(body),
    };
    return await API(obj);
  }
);

export const getPromoCodes = createAsyncThunk(
  "getPromoCodes",
  async () => {
    const obj = {
      url: `${APIEndPoints.PromoCodesAPI}`,
      method: "GET",
    };
    return await API(obj);
  }
);

export const createPromoCodeRule = createAsyncThunk(
  "createPromoCodeRule",
  async ({ promo_id, body }) => {
    const obj = {
      url: `${APIEndPoints.PromoCodeRulesAPI}${promo_id}/rules/`,
      method: "POST",
      body: JSON.stringify(body),
    };
    return await API(obj);
  }
);

export const updatePromoCodeRule = createAsyncThunk(
  "updatePromoCodeRule",
  async ({ promo_id, rule_id, body }) => {
    const obj = {
      url: `${APIEndPoints.PromoCodeRulesAPI}${promo_id}/rules/${rule_id}/`,
      method: "PATCH",
      body: JSON.stringify(body),
    };
    return await API(obj);
  }
);

export const deletePromoCode = createAsyncThunk(
  "deletePromoCode",
  async ({ promo_id }) => {
    const obj = {
      url: `${APIEndPoints.PromoCodesAPI}${promo_id}/`,
      method: "DELETE",
      isResponseJSON: false,
    };
    const res = await API(obj);
    if (!res.ok) {
      throw new Error("Something went wrong while deleting promo code!");
    }
    return { success: true };
  }
);

export const sendPromoCode = createAsyncThunk(
  "sendPromoCode",
  async ({ promo_id, body }) => {
    const obj = {
      url: `${APIEndPoints.PromoCodesAPI}${promo_id}/send/`,
      method: "POST",
      body: JSON.stringify(body),
    };
    return await API(obj);
  }
);

export const getPromoUsers = createAsyncThunk(
  "getPromoUsers",
  async (params = {}) => {
    const { promo_id, page, size, search, service_type, is_used, is_sent } = params;
    let url = `${APIEndPoints.PromoCodesAPI}users/`;

    const queryParts = [];
    if (promo_id) queryParts.push(`promo_id=${encodeURIComponent(promo_id)}`);
    if (page) queryParts.push(`page=${encodeURIComponent(page)}`);
    if (size) queryParts.push(`size=${encodeURIComponent(size)}`);
    if (search) queryParts.push(`search=${encodeURIComponent(search)}`);
    if (service_type) queryParts.push(`service_type=${encodeURIComponent(service_type)}`);
    if (is_used !== undefined && is_used !== null && is_used !== "") {
      queryParts.push(`is_used=${encodeURIComponent(is_used)}`);
    }
    if (is_sent !== undefined && is_sent !== null && is_sent !== "") {
      queryParts.push(`is_sent=${encodeURIComponent(is_sent)}`);
    }

    if (queryParts.length > 0) {
      url += `?${queryParts.join("&")}`;
    }

    const obj = {
      url,
      method: "GET",
    };
    return await API(obj);
  }
);

